/**
 * Create a new sorted list of facets with additional properties given a list of FB Facets
 * @author Ryan McAvoy
 * @date 2023-11-29
 * @param {any} facets
 * @param {any} facetOverride={}
 * @returns {array}
 */
const resolveFacetItems = (facets, facetOverride = {}) => {
  const newFacets = {};
  const rangeRegex = /__start$|__end$/;

  for (const [key, facet] of Object.entries(facets)) {
    if (rangeRegex.test(facet.name)) {
      const rangeName = facet.name.replace(rangeRegex, '');

      // Create range if it doesn't already exist
      if (!newFacets[rangeName]) {
        newFacets[rangeName] = {
          ...facet,
          facetType: facet.facetType,
          label: facet.label.replace(rangeRegex, ''),
        };
      }

      // Set items if range start
      if (facet.name.includes('__start')) {
        newFacets[rangeName].nameStart = facet.name;
        newFacets[rangeName].idStart = facet.id;
      }

      // Set items if range end
      if (facet.name.includes('__end')) {
        newFacets[rangeName].nameEnd = facet.name;
        newFacets[rangeName].idEnd = facet.id;
      }
    } else {
      let newFacet = facet;

      // process any overrides from config
      if (facetOverride[key]) {
        newFacet = { ...facet, ...facetOverride[key] };
      }

      newFacets[key] = { ...newFacet };
    }
  }
  let sortedFacets = Object.values(newFacets);
  sortedFacets.sort((a, b) => a.facetOrder - b.facetOrder);

  return sortedFacets;
};

export default resolveFacetItems;
